import { Component } from '@angular/core';


@Component({
    selector: 'app-about-dialog',
    templateUrl: './about-dialog.component.html',
    styleUrls: ['./about-dialog.component.scss'],
    imports: []
})
export class AboutDialogComponent {
}
